// extracted by mini-css-extract-plugin
module.exports = {"tags-title":"tags_tags-title__R79Y6","tags-links":"tags_tags-links__ku5uL"};